import GroupNotesWrapper from "@/pages/groups/notes/GroupNotesWrapper"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute("/beheer/groepen/$groupId/notities/")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "groups"),
})

function RouteComponent() {
  const { groupId } = useParams({
    from: "/beheer/groepen/$groupId",
  })

  return <GroupNotesWrapper groupId={Number(groupId)} />
}
